import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiArrowLeft } from "@mdi/js";
import { Button, Tabs } from "@heroui/react";
import { ROUTES } from "@/constants/routes";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";
import FaqTab from "./components/FaqTab";
import TopicsTab from "./components/TopicsTab";
import NotificationsTab from "./components/NotificationsTab";
import FaqFormDrawer from "./components/FaqFormDrawer";
import TopicFormDrawer from "./components/TopicFormDrawer";
import DeleteConfirmModal from "./components/DeleteConfirmModal";
import "../FeedbackPage/components/FeedbackDrawer.css";
import "./FeedbackSettingsPage.css";

type SettingsTabId = "faq" | "topics" | "notifications";

const FeedbackSettingsPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<SettingsTabId>("faq");

  useEffect(() => {
    void feedbackSettingsStore.loadAll();
    return () => feedbackSettingsStore.reset();
  }, []);

  return (
    <div className="fbs-page" data-testid="feedback-settings-page">
      <div className="fbs-page__header">
        <Button
          isIconOnly
          variant="ghost"
          size="sm"
          aria-label="Назад к обращениям"
          onPress={() => navigate(ROUTES.FEEDBACK)}
        >
          <Icon path={mdiArrowLeft} size={0.85} />
        </Button>
        <div>
          <h1 className="fbs-page__title">Настройки обратной связи</h1>
          <p className="fbs-page__subtitle">
            FAQ, темы обращений и уведомления
          </p>
        </div>
      </div>

      <Tabs
        className="fbs-tabs"
        selectedKey={activeTab}
        onSelectionChange={(key) => {
          feedbackSettingsStore.cancelFaqOrderMode();
          feedbackSettingsStore.cancelTopicOrderMode();
          if (
            feedbackSettingsStore.isNotificationsDirty &&
            key !== "notifications"
          ) {
            const confirmed = window.confirm(
              "Есть несохранённые изменения в настройках уведомлений. Продолжить без сохранения?",
            );
            if (!confirmed) return;
            feedbackSettingsStore.resetNotificationsForm();
          }
          setActiveTab(key as SettingsTabId);
        }}
      >
        <Tabs.ListContainer>
          <Tabs.List aria-label="Разделы настроек">
            <Tabs.Tab id="faq">
              FAQ
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id="topics">
              Темы обращений
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id="notifications">
              Уведомления
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>

        <Tabs.Panel id="faq">
          <FaqTab />
        </Tabs.Panel>
        <Tabs.Panel id="topics">
          <TopicsTab />
        </Tabs.Panel>
        <Tabs.Panel id="notifications">
          <NotificationsTab />
        </Tabs.Panel>
      </Tabs>

      <FaqFormDrawer />
      <TopicFormDrawer />
      <DeleteConfirmModal />
    </div>
  );
});

FeedbackSettingsPage.displayName = "FeedbackSettingsPage";
export default FeedbackSettingsPage;
